import React from 'react';
import { Link } from 'react-router-dom';

const Knowledge = () => {
  const knowledgeTools = [
    {
      id: 'appraisal-institutions',
      name: '珠宝鉴定机构目录',
      description: '按地区列出官方珠宝鉴定机构信息',
      icon: '🏛️',
      path: '/knowledge/appraisal-institutions'
    },
    {
      id: 'crystal-identification',
      name: '水晶/宝石辨别小课堂',
      description: '常见水晶的肉眼辨别要点和假冒品对比',
      icon: '💎',
      path: '/knowledge/crystal-identification'
    },
    {
      id: 'faq',
      name: '常见问题与术语解释',
      description: '手链制作常见疑问和专业术语解释',
      icon: '❓',
      path: '/knowledge/faq'
    },
    {
      id: 'maintenance-tips',
      name: '手链保养小贴士',
      description: '防氧化、清洗、存放等保养方法',
      icon: '🧽',
      path: '/knowledge/maintenance-tips'
    },
    {
      id: 'material-comparison',
      name: '手链材料对比表',
      description: '不同材质的硬度、价格区间和适用人群',
      icon: '📊',
      path: '/knowledge/material-comparison'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-indigo-800">
          知识库
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {knowledgeTools.map((tool) => (
            <Link
              key={tool.id}
              to={tool.path}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300 border border-purple-100"
            >
              <div className="text-4xl mb-4">{tool.icon}</div>
              <h2 className="text-xl font-semibold mb-2 text-indigo-700">
                {tool.name}
              </h2>
              <p className="text-gray-600">{tool.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Knowledge;